var React = require('react');

function BusinessMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#FFF","strokeWidth":".582","transform":"translate(.572 .639)"},[React.createElement("rect",{"width":"9.985","height":"5.463","y":"3.694","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2.73920201,-1.81540917e-07 L2.73920201,1.03615306 C2.73920201,1.60759452 3.20271521,2.07230631 3.77293893,2.07230631 L6.2118105,2.07230631 C6.78379989,2.07230631 7.24554744,1.60926225 7.24554744,1.03615306 L7.24554744,-1.81540917e-07 L2.73920201,-1.81540917e-07 Z","transform":"rotate(-180 4.992 1.036)","key":1}),React.createElement("rect",{"width":"9.985","height":"1.507","y":"2.186","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

BusinessMenu.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11"};

module.exports = BusinessMenu;

BusinessMenu.default = BusinessMenu;
